import { Config } from '@cian/config';
import * as React from 'react';

import { CloseBtn } from '../../../common/components/close_button/index';
import { Modal } from '../../../common/components/modal';
import { ModalWrapper } from '../../../common/components/modal/wrapper';

import { IJsonQuery } from '../../../json_query';
import { AdvancedModalFooterContainer } from './modal_footer/container';

import { ILocation } from '../../../api/locations';
import {
  isParamAvailable,
  dealTypeFromJsonQuery,
  FDealType,
  FOfferType,
  offerTypeFromJsonQuery,
} from '../../../utils/category';
import { getParams } from './params';
import { commercialLandParams } from './params_lists/commercial_land_params';
import { commercialParams } from './params_lists/commercial_params';
import { commercialCoworkingParams } from './params_lists/commercial_coworking_params';
import { suburbanParams } from './params_lists/suburban_params';
import { urbanParams } from './params_lists/urban_params';

const style = require('./index.css');

export interface IAdvancedProps {
  jsonQuery: IJsonQuery;
  currentLocation: ILocation | 'moscow_mo' | 'spb_lo';
  config: Config;

  close(): void;
}

interface IShowCondition {
  dealType: FDealType;
  offerType: FOfferType;
  custom?: boolean;
}

export interface IParam {
  showCondition: IShowCondition;
  distinctJsonQuery?(jsonQuery: IJsonQuery): IJsonQuery;
  clearJsonQuery?(jsonQuery: IJsonQuery): IJsonQuery;
  element: React.ReactNode;
}

const getFiltersElements = (params: IParam[], offerType: FOfferType, dealType: FDealType) =>
  params.map(
    param =>
      isParamAvailable(dealType, offerType)(
        param.showCondition.dealType,
        param.showCondition.offerType,
        param.showCondition.custom,
      ) && param.element,
  );

export class Advanced extends React.Component<IAdvancedProps> {
  private dealType: FDealType;
  private offerType: FOfferType;

  public constructor(props: IAdvancedProps) {
    super(props);

    this.dealType = dealTypeFromJsonQuery(props.jsonQuery);
    this.offerType = offerTypeFromJsonQuery(props.jsonQuery);
  }

  public render() {
    const { currentLocation, jsonQuery, config } = this.props;

    const allParams = getParams({ jsonQuery, currentLocation, config });
    let params: IParam[] = [];

    if (this.offerType & FOfferType.Urban) {
      params = urbanParams.map(param => allParams[param]);
    } else if (this.offerType & FOfferType.Suburban) {
      params = suburbanParams.map(param => allParams[param]);
    } else if (this.offerType & FOfferType.Commercial & ~FOfferType.CommercialLand & ~FOfferType.Coworking) {
      params = commercialParams.map(param => allParams[param]);
    } else if (this.offerType & FOfferType.Coworking) {
      params = commercialCoworkingParams.map(param => allParams[param]);
    } else if (this.offerType & FOfferType.CommercialLand) {
      params = commercialLandParams.map(param => allParams[param]);
    }

    return (
      <ModalWrapper onClose={this.props.close}>
        <Modal
          minHeigth={400}
          minWidth={952}
          width="85%"
          footer={<AdvancedModalFooterContainer />}
          closeBtn={<CloseBtn onClick={this.props.close} isTransparent />}
        >
          <div className={style['advanced']}>
            <div className={style['table']}>{getFiltersElements(params, this.offerType, this.dealType)}</div>
          </div>
        </Modal>
      </ModalWrapper>
    );
  }
}
